import React, { useMemo } from "react";
import { OrderItemType } from "../../../recoil/type";

interface HeaderProps {
  isNew: boolean;
  status: number;
  setStatus: (status: number) => void;
  preparedList: OrderItemType[];
  checkedList: OrderItemType[];
  completedList: OrderItemType[];
}

const StatusTab = ({
  isNew,
  status,
  setStatus,
  preparedList,
  checkedList,
  completedList,
}: HeaderProps) => {
  const StatusTab = useMemo(() => {
    return (
      <div className="statusWrap">
        <div
          className={`statusItem ${status === 0 && "active"}`}
          onClick={() => setStatus(0)}
        >
          {isNew && (
            <div className="newButton">
              <h5>NEW</h5>
            </div>
          )}
          <h3>접수대기</h3>
          <h3>{preparedList.length}</h3>
        </div>
        <div
          className={`statusItem ${status === 1 && "active"}`}
          onClick={() => setStatus(1)}
        >
          <h3>처리중</h3>
          <h3>{checkedList.length}</h3>
        </div>
        <div
          className={`statusItem ${status === 2 && "active"}`}
          onClick={() => setStatus(2)}
        >
          <h3>완료/취소</h3>
          <h3>{completedList.length}</h3>
        </div>
      </div>
    );
  }, [
    preparedList.length,
    checkedList.length,
    completedList.length,
    status,
    isNew,
  ]);

  return StatusTab;
};
export default StatusTab;
